<template>
  <div class="base-mask" v-if="display">
    <transition>
      <div class="base-modal__wrap" v-if="display">
        <div class="modal-header">{{ title }}</div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <slot name="footer">
          <div class="modal-footer">
            <n-button @click="handleOk" size="medium">确定</n-button>
            <n-button type="default" size="medium" @click="handleCancel">取消</n-button>
          </div>
        </slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      default: "下载",
      type: String,
    },
    show: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      errMsg: "",
      favname: "默认收藏夹",
      display: this.show,
    };
  },
  watch: {
    show: {
      handler(val) {
        this.display = val;
      },
    },
  },
  methods: {
    handleCancel() {
      this.display = false;
      this.$emit("update:show", false);
      this.$emit("close");
    },
    handleOk() {
      this.$emit("update:show", false);
      this.$emit("ok");
    },
    handleClose() {
      console.log("close");
      this.display = false;
      this.$emit("update:show", false);
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.base-mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1999;
  .base-modal__wrap {
    width: 462px;
    border-radius: 6px;
    position: absolute;
    background-color: #fff;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    > .modal-header {
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      width: 100%;
      height: 52px;
      line-height: 52px;
      text-align: center;
      color: #fff;
      font-size: 20px;

      background-color: $primaryColor;
      user-select: none;
    }
    .modal-body {
      padding: 12px 0px;
      width: 100%;
      min-height: 126px;
    }
    .modal-footer {
      width: 100%;
      display: flex;
      justify-content: center;
      padding-bottom: 22px;
      .n-button {
        height: 40px;
        line-height: 40px;
        width: 120px;
        margin: 0 36px;
      }
    }
  }
}
</style>
